import NoSSR from "@mpth/react-no-ssr";
import React, { useEffect, useState } from "react";
import { Box, Text } from "@chakra-ui/react";
import { CodeChallengeEditor } from "./CodeChallengeEditor";
import { CodeChallengeLoading } from "./CodeChallengeLoading";
import { FiZap } from "react-icons/fi";
import { LoadEditorData } from "./LoadEditorData";
import { TaskContent, TaskEvent, TaskWrapper, useTask } from "../Task";

type CodeChallengeProps = {
  taskId: string;
  description?: string;
  externalId?: string;
};

export function CodeChallenge({
  taskId,
  description,
  externalId,
}: CodeChallengeProps) {
  // we have to maintain two sets of "complete" state because the component
  // could be used by a logged-out user (no mutations will be fired)
  const [complete, setComplete] = useState(false);
  const { courseId, loadingUser, isTaskComplete } = useTask(taskId);
  useEffect(() => setComplete(isTaskComplete), [isTaskComplete]);

  return (
    <TaskWrapper
      icon={FiZap}
      title="Code Challenge!"
      isComplete={complete}
      taskId={taskId}
    >
      {description && (
        <Text mb="2">
          <TaskContent>{description}</TaskContent>
        </Text>
      )}
      <NoSSR>
        <Box mt="4">
          {loadingUser ? (
            <CodeChallengeLoading>Loading progress</CodeChallengeLoading>
          ) : (
            <LoadEditorData courseId={externalId || courseId} taskId={taskId}>
              {(data, functionUrl) => (
                <CodeChallengeEditor
                  taskId={taskId}
                  complete={complete}
                  setComplete={setComplete}
                  data={data}
                  functionUrl={functionUrl}
                />
              )}
            </LoadEditorData>
          )}
        </Box>
      </NoSSR>
      <TaskEvent taskId={taskId} isComplete={complete} />
    </TaskWrapper>
  );
}
